import React from 'react';
import PropTypes from 'prop-types';

import AboutUsPage from '../pagesComponents/aboutUsPage';
import Layout from '../components/layout';


const AboutUs = ({ location }) => (
  <Layout location={location}>
    <AboutUsPage />
  </Layout>
);

AboutUs.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

export default AboutUs;
